import React, { createContext, useContext, ReactNode } from "react";
import { useUser } from "./UserInfoProvider";

// Define the possible roles
export type UserRole = "ADMIN" | "MANAGER" | "STAFF" | "HR" | "UNKNOWN";

interface RoleContextType {
  userRole: UserRole;
  // Add any role-related functions here if needed in the future, e.g., refreshRole
}

const RoleContext = createContext<RoleContextType | undefined>(undefined);

export const RoleProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { userInfo } = useUser();

  const normalizeRole = (raw?: string): UserRole => {
    if (!raw) return "UNKNOWN";
    const upper = raw.toUpperCase();
    if (upper.includes("ADMIN") || upper.includes("GENERAL MANAGER"))
      return "ADMIN";
    if (upper.includes("MANAGER")) return "MANAGER";
    if (upper === "HR" || upper === "H R" || upper.includes("HR")) return "HR";
    if (upper.includes("STAFF")) return "STAFF";
    return "UNKNOWN";
  };

  const userRole: UserRole = normalizeRole(userInfo?.role ?? userInfo?.roleId);

  // Later, you might have logic here to fetch the role from an API:
  // const [userRole, setUserRole] = useState<UserRole>('UNKNOWN');
  // useEffect(() => {
  //   // fetchUserRole().then(role => setUserRole(role));
  // }, []);

  return (
    <RoleContext.Provider value={{ userRole }}>{children}</RoleContext.Provider>
  );
};

export const useRole = (): RoleContextType => {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return context;
};
